import ROUTES from "./routes";

const MENU_ITEMS = [
  {
    id: "dashboard",
    label: "داشبورد",
    path: ROUTES.DASHBOARD,
  },
  {
    id: "teacher-dashboard",
    label: "داشبورد معلم",
    children: [
      {
        id: "teacher-classes",
        label: "درس‌های من",
        path: ROUTES.TEACHER_CLASSES,
      },
      {
        id: "teacher-school-notifications",
        label: "اعلان های مدرسه",
        path: ROUTES.TEACHER_SCHOOL_NOTIFICATIONS,
        reviewKey: "notifications",
      },
      {
        id: "teacher-weekly-schedule",
        label: "برنامه هفتگی",
        path: ROUTES.TEACHER_WEEKLY_SCHEDULE,
      },
    ],
  },
  {
    id: "class-management",
    label: "مدیریت کلاس",
    children: [
      {
        id: "students-list",
        label: "لیست دانش‌آموزان",
        path: ROUTES.CLASS_STUDENTS,
      },
      {
        id: "students-leveling",
        label: "ثبت ارزشیابی",
        path: ROUTES.CLASS_LEVELING,
      },
      {
        id: "attendance",
        label: "ثبت حضور و غیاب",
        path: ROUTES.CLASS_ATTENDANCE,
      },
      {
        id: "class-behavior",
        label: "ثبت شایستگی های عمومی",
        path: ROUTES.CLASS_BEHAVIOR,
      },
      {
        id: "class-report-card",
        label: "کارنامه",
        path: ROUTES.CLASS_REPORT_CARD,
      },
    ],
  },
  {
    id: "assignment-management",
    label: "تکالیف",
    children: [
      {
        id: "assignment-definition",
        label: "تعریف تکلیف",
        path: ROUTES.ASSIGNMENT_DEFINITION,
      },
      {
        id: "teacher-assignments",
        label: "مدیریت تکالیف",
        path: ROUTES.TEACHER_ASSIGNMENTS,
        reviewKey: "homeworks",
      },
    ],
  },
  {
    id: "challenge-management",
    label: "چالش‌ها",
    children: [
      {
        id: "challenge-definition",
        label: "تعریف چالش",
        path: ROUTES.CHALLENGE_DEFINITION,
      },
      {
        id: "teacher-challenges",
        label: "مدیریت چالش‌ها",
        path: ROUTES.TEACHER_CHALLENGES,
        reviewKey: "challenges",
      },
    ],
  },
  {
    id: "exam-management",
    label: "آزمون‌ها",
    children: [
      {
        id: "exam-definition",
        label: "تعریف آزمون",
        path: ROUTES.EXAM_DEFINITION,
      },
      {
        id: "teacher-active-tests",
        label: "مدیریت آزمون‌ها",
        path: ROUTES.TEACHER_ACTIVE_TESTS,
        reviewKey: "exams",
      },
    ],
  },
  {
    id: "content-management",
    label: "محتوا",
    children: [
      {
        id: "content-manage",
        label: "مدیریت محتوا",
        path: ROUTES.CONTENT_MANAGEMENT,
      },
    ],
  },
  {
    id: "ai-assistant",
    label: "دستیار هوش مصنوعی",
    children: [
      {
        id: "ai-exam-generation",
        label: "تولید آزمون",
        path: ROUTES.AI_EXAM_GENERATION,
      },
      {
        id: "ai-assignment-generation",
        label: "تولید تکلیف",
        path: ROUTES.AI_ASSIGNMENT_GENERATION,
      },
      {
        id: "ai-image-generation",
        label: "تولید تصویر آموزشی",
        path: ROUTES.AI_IMAGE_GENERATION,
      },
      {
        id: "ai-lesson-plan-generation",
        label: "تولید طرح درس",
        path: ROUTES.AI_LESSON_PLAN_GENERATION,
      },
      {
        id: "ai-lesson-summary",
        label: "خلاصه درس",
        path: ROUTES.AI_LESSON_SUMMARY,
      },
    ],
  },
];

export default MENU_ITEMS;
